module.exports = __webpack_public_path__ + "static/pic01.53bd1d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic01.jpg
// module id = 186
// module chunks = 35783957827783 114276838955818